
import AppDossierInfo from "@/components/dossier/DossierInfo.vue";
import AppDossierInfoUser from "@/components/dossier/DossierInfoUsers.vue";
import AppDossierInfoScripts from "@/components/dossier/DossierInfoScripts.vue";
import Vue from "vue";

import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyDossierService } from "@/services/company-dossier-service";
import { CompanyService } from "@/services/company-service";
import { setTitle, resetTitle } from "@/utils/title";
import AppDossierCalculatedFieldsInfo from "@/components/dossier/DossierCalculatedFieldsInfo.vue";
import AppDossierBrowseExtraButtonInfo from "@/components/dossier/DossierBrowseExtraButtonInfo.vue";


export default Vue.extend({
	data() {
		return {
			currentTab: 0,
			company: new Company(),
			dossier: new Dossier(),
			loaded: false
		};
	},
	computed: {
		tabs():string[] {
			return [
				"Dossier",
				"Users",
				"Scripts",
				"Berekende velden",
				"Browse extra knoppen"
			];
		},
		goToCompanyToolTipText():string {
			return "Back to company";
		},
		editDossierToolTipText():string {
			return "Switch to edit mode";
		}
	},
	methods: {
		goToCompany() {
			this.$router.push({path: `/companies/${this.dossier.companyId}/info`, query: { currentTab: "2"} });
		},
		editDossier() {
			this.$router.push( {path: `/companies/${this.dossier.companyId}/dossier/${this.dossier.id}/edit`, query: { currentTab: `${this.currentTab}` } } );
		}
	},
	async created() {
		this.company = await CompanyService.getCompany(parseInt(this.$route.params.companyId));
		if (this.$route.params.dossierId) {
			this.dossier = await CompanyDossierService.getDossier(this.company.id, parseInt(this.$route.params.dossierId));
		}
		setTitle(this.dossier.name);
		this.dossier.companyId = this.company.id;
		this.loaded = true;

		//if current tab is set go to and remove querry from url
		if (this.$route.query.currentTab) {
			this.currentTab = parseInt(this.$route.query.currentTab[0] || "0");
			let query = Object.assign({}, this.$route.query);
			delete query.currentTab;
			this.$router.replace({ query });
		}
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppDossierInfo,
		AppDossierInfoUser,
		AppDossierInfoScripts,
		AppDossierCalculatedFieldsInfo,
		AppDossierBrowseExtraButtonInfo
	}
});
